/* eslint-disable max-len */
import ImageConverter from '../../../../../infrastructure/module/dependent/image/image-toolkit/image-converter';
import { ImageCanvasOptions } from '@src/slide/application/service/copy-paste/core/plugin/types';
import { ClipboardType } from '../types';
import {
    ICanvasRendererService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/base/canvas-renderer-service.interface';
import {
    IPcEditorAreaService,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/pc-content-service.interface';

export const SUPPORT_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'image/svg+xml'];

export interface ImageBlobAndString {
    imgStr: string,
    imgBlob: Blob
}

class ImagePreparePlugin {
    public async getImageBlobAndString(
        domContainer: HTMLElement,
        outputOptions: ImageCanvasOptions,
        contentRendererService?: ICanvasRendererService,
    ): Promise<ImageBlobAndString> {
        const imgStr = await (contentRendererService as IPcEditorAreaService)?.copyToImage.generateImageUrl(outputOptions);
        domContainer?.remove();
        const imgBlob = await this.getImageBlob(imgStr);
        return { imgStr, imgBlob };
    }

    public getImageBlob(imgStr: string): Blob {
        return this.dataBase64ToBlob(imgStr);
    }

    /**
     * base64转blob的过程
     * @param {string} dataURI  图片url
     * @returns {Blob}
     */
    private dataBase64ToBlob(dataURI) {
        const defaultPngBlob = new Blob([], { type: ClipboardType.IMAGE_PNG });
        if (!this.isBase64Png(dataURI)) {
            return defaultPngBlob;
        }

        const blob = ImageConverter.convertDataUriToBlob(dataURI);
        if (!blob) {
            return defaultPngBlob;
        }

        return blob;
    }

    /**
     * url是否是base64png
     * @param {string} url 图片url
     * @returns {boolean}
     */
    private isBase64Png(url: string) {
        if (!url || typeof url !== 'string') {
            return false;
        }
        return url.startsWith('data:image/png;base64');
    }
}

export default ImagePreparePlugin;
